import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

interface TipItem {
  icon: string;
  title: string;
  description: string;
  route: string;
}

@Component({
  selector: 'app-your-tips',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './your-tips.component.html',
  styleUrls: ['./your-tips.component.css']
})
export class YourTipsComponent implements OnInit {
  tipItems: TipItem[] = [
    { icon: 'assets/icon-tips-recent.png', title: 'Recent Tips', description: 'See recently published tips', route: '/your-tips/recent-tips' },
    { icon: 'assets/icon-tips-popular.png', title: 'Popular Tips', description: 'See most liked advices', route: '/your-tips/recent-tips' },
    { icon: 'assets/icon-submit-tip.png', title: 'Submit a Tip!', description: 'Click here to share your advice with others', route: '/your-tips/submit-a-tip' }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void { }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
